export const formatTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60

  if (hours > 0) {
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
  } else {
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
  }
}

export const getTimerColor = (remainingSeconds: number, totalSeconds: number): string => {
  const percentageRemaining = (remainingSeconds / totalSeconds) * 100
  
  if (percentageRemaining <= 5) {
    return 'timer-danger'
  } else if (percentageRemaining <= 15) {
    return 'timer-warning'
  } else {
    return 'timer-normal'
  }
}

export const shouldShowWarning = (remainingSeconds: number, totalDurationMinutes?: number): 'none' | 'warning' | 'critical' => {
  // If no total duration provided, use old behavior
  if (!totalDurationMinutes) {
    if (remainingSeconds <= 300) { // 5 minutes
      return 'critical'
    } else if (remainingSeconds <= 900) { // 15 minutes
      return 'warning'
    }
    return 'none'
  }

  const totalSeconds = totalDurationMinutes * 60
  
  // Critical warning: 5 minutes remaining OR 10% of total time (whichever is less)
  const criticalThreshold = Math.min(300, totalSeconds * 0.1)
  
  // Warning: 15 minutes remaining OR 25% of total time (whichever is less)
  // Only show warning if test is longer than 20 minutes
  const warningThreshold = totalDurationMinutes > 20 ? Math.min(900, totalSeconds * 0.25) : 0
  
  if (remainingSeconds <= criticalThreshold) {
    return 'critical'
  } else if (warningThreshold > 0 && remainingSeconds <= warningThreshold) {
    return 'warning'
  }
  
  return 'none'
}

export const getWarningMessage = (remainingSeconds: number): string => {
  const minutes = Math.ceil(remainingSeconds / 60)
  return `${minutes} minute${minutes !== 1 ? 's' : ''} remaining`
}

export const calculateElapsedTime = (startTime: string): number => {
  const start = new Date(startTime)
  const now = new Date()
  return Math.floor((now.getTime() - start.getTime()) / 1000)
}

export const isTimerCritical = (remainingSeconds: number): boolean => {
  return remainingSeconds <= 300 // 5 minutes
}

export const getTimeDisplayProps = (remainingSeconds: number, totalSeconds: number) => {
  const color = getTimerColor(remainingSeconds, totalSeconds)
  const critical = isTimerCritical(remainingSeconds)
  
  return {
    color,
    critical,
    formatted: formatTime(remainingSeconds),
    className: `timer-display ${color} ${critical ? 'countdown-pulse' : ''}`
  }
}
